import { render } from "./TargetContainer.vue?vue&type=template&id=e983deb6&scoped=true"
import script from "./TargetContainer.vue?vue&type=script&lang=ts"
export * from "./TargetContainer.vue?vue&type=script&lang=ts"

import "./TargetContainer.vue?vue&type=style&index=0&id=e983deb6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e983deb6"

export default script